export class GraphConstants {
  public static eventsBarCountOld = 20;
  public static eventsBarCountNew = 30;
  public static destinationEventsBarCount = 40;
  public static activationEventsBarCount = 30;
}
